import type { CurrencyNumberFormatOptions } from '@intlify/core-base'

export const BGN: CurrencyNumberFormatOptions = {
  style: 'currency',
  currency: 'BGN',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
}

export const CHF: CurrencyNumberFormatOptions = {
  style: 'currency',
  currency: 'CHF',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
}

export const CZK: CurrencyNumberFormatOptions = {
  style: 'currency',
  currency: 'CZK',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 0,
}

export const DKK: CurrencyNumberFormatOptions = {
  style: 'currency',
  currency: 'DKK',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
}

export const EUR: CurrencyNumberFormatOptions = {
  style: 'currency',
  currency: 'EUR',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
}

export const GBP: CurrencyNumberFormatOptions = {
  style: 'currency',
  currency: 'GBP',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
}

export const HUF: CurrencyNumberFormatOptions = {
  style: 'currency',
  currency: 'HUF',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 0,
}

export const NOK: CurrencyNumberFormatOptions = {
  style: 'currency',
  currency: 'NOK',
  currencyDisplay: 'narrowSymbol',
  minimumFractionDigits: 0,
}

export const PLN: CurrencyNumberFormatOptions = {
  style: 'currency',
  currency: 'PLN',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
}

export const RON: CurrencyNumberFormatOptions = {
  style: 'currency',
  currency: 'RON',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
}

export const SEK: CurrencyNumberFormatOptions = {
  style: 'currency',
  currency: 'SEK',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
}

export const TRY: CurrencyNumberFormatOptions = {
  style: 'currency',
  currency: 'TRY',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
}

export const UAH: CurrencyNumberFormatOptions = {
  style: 'currency',
  currency: 'UAH',
  currencyDisplay: 'narrowSymbol',
  minimumFractionDigits: 0,
}

export const USD: CurrencyNumberFormatOptions = {
  style: 'currency',
  currency: 'USD',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
}
